module.exports = __webpack_public_path__ + "static/media/reya_sunshine.187fd6ea.png";